const PATTERNS = [
  '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
  '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
  '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
  '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
  '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
  '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
  '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
  '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
  '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
  '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
  '114131', '311141', '411131', '211412', '211214', '211232', '2331112',
];

const escapeHtml = (value) => String(value == null ? '' : value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

const code128Svg = (text) => {
  const value = String(text || '').trim();
  const codes = [104];
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i) - 32;
    if (code < 0 || code > 95) return '';
    codes.push(code);
  }
  let checksum = codes[0];
  for (let i = 1; i < codes.length; i += 1) checksum += codes[i] * i;
  codes.push(checksum % 103);
  codes.push(106);
  const modules = codes.map((code) => PATTERNS[code]).join('');
  const quiet = 10;
  const unit = 2;
  const width = (quiet * 2 + modules.length) * unit;
  const height = 72;
  let x = quiet * unit;
  let bars = '';
  for (let i = 0; i < modules.length; i += 1) {
    const w = Number(modules[i]) * unit;
    if (i % 2 === 0) {
      bars += `<rect x="${x}" y="0" width="${w}" height="${height}" fill="#040921"/>`;
    }
    x += w;
  }
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">${bars}</svg>`;
};

const pickRows = (orders) => {
  const rows = [];
  (orders || []).forEach((order) => {
    if (!order || !order.order_code) return;
    const lines = order.lines && order.lines.length
      ? order.lines
      : [{ bin_id: '', product_name: '', suggested_qty: '' }];
    lines.forEach((line) => {
      rows.push({
        order_code: order.order_code,
        bin_id: line.bin_id,
        product_name: line.product_name,
        suggested_qty: line.suggested_qty,
        boh: line.boh != null ? line.boh : line.boh_at_create,
        min_qty: line.min_qty,
        max_qty: line.max_qty,
      });
    });
  });
  return rows;
};

const displayCount = (value) => {
  if (value == null || value === '') return '—';
  const parsed = Number(value);
  return Number.isFinite(parsed) ? String(parsed) : '—';
};

export const printPickLists = (orders, options = {}) => {
  const rows = pickRows(orders);
  if (!rows.length) return;
  const location = escapeHtml(options.locationName || '');
  const html = `<!DOCTYPE html><html><head><title>Shop pick list</title>
    <style>
      @page { size: letter landscape; margin: 0.55in; }
      * { box-sizing: border-box; }
      html, body { margin: 0; padding: 0; background: #fff; }
      body {
        padding: 0.45in 0.5in;
        font-family: Arial, Helvetica, sans-serif;
        color: #102a2e;
      }
      .banner {
        background: #0a5d66;
        color: #fff;
        border-radius: 12px;
        padding: 16px 20px;
        margin: 0 0 18px;
      }
      .banner h1 { margin: 0; font-size: 20px; letter-spacing: 0.06em; font-weight: 700; }
      .banner p { margin: 6px 0 0; font-size: 13px; line-height: 1.4; color: #d7eef0; }
      table { width: 100%; border-collapse: collapse; table-layout: fixed; }
      thead { display: table-header-group; }
      th {
        text-align: left;
        font-size: 11px;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #5b6b70;
        padding: 0 12px 8px;
        border-bottom: 2px solid #0a5d66;
      }
      td {
        padding: 12px;
        vertical-align: middle;
        font-size: 14px;
        border-bottom: 1px solid #e4ecee;
        overflow: hidden;
        word-wrap: break-word;
      }
      tr, td { break-inside: avoid; page-break-inside: avoid; }
      tbody tr:nth-child(even) td { background: #f7fafa; }
      th.barcode, td.barcode { width: 28%; }
      th.bin, td.bin { width: 8%; font-weight: 700; }
      th.num, td.num { width: 9%; text-align: right; font-weight: 700; }
      td.num { color: #102a2e; }
      th.qty, td.qty { width: 9%; text-align: right; font-weight: 700; color: #0a5d66; }
      .barcode-wrap {
        display: inline-block;
        max-width: 100%;
        padding: 8px 10px 6px;
        background: #fff;
        border: 1px solid #e4ecee;
        border-radius: 8px;
        line-height: 0;
      }
      .barcode-wrap svg { display: block; width: 180px; max-width: 100%; height: 48px; }
      .code {
        display: block;
        margin-top: 8px;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.08em;
        line-height: 1.2;
        text-align: center;
        color: #102a2e;
      }
    </style></head><body>
    <div class="banner">
      <h1>SHOP PICK LIST</h1>
      <p>${location ? `${location} · ` : ''}Scan each code at the kiosk under Load.</p>
    </div>
    <table>
      <thead>
        <tr>
          <th class="barcode">Load code</th>
          <th class="bin">Bin</th>
          <th>Item</th>
          <th class="num">On hand</th>
          <th class="num">Min</th>
          <th class="num">Max</th>
          <th class="qty">Load</th>
        </tr>
      </thead>
      <tbody>
        ${rows.map((row) => `
          <tr>
            <td class="barcode">
              <div class="barcode-wrap">
                ${code128Svg(row.order_code)}
                <span class="code">${escapeHtml(row.order_code)}</span>
              </div>
            </td>
            <td class="bin">${escapeHtml(row.bin_id)}</td>
            <td>${escapeHtml(row.product_name)}</td>
            <td class="num">${escapeHtml(displayCount(row.boh))}</td>
            <td class="num">${escapeHtml(displayCount(row.min_qty))}</td>
            <td class="num">${escapeHtml(displayCount(row.max_qty))}</td>
            <td class="qty">${escapeHtml(displayCount(row.suggested_qty))}</td>
          </tr>
        `).join('')}
      </tbody>
    </table>
    <script>
      (function () {
        var done = false;
        var finish = function () {
          if (done) return;
          done = true;
          try {
            parent.postMessage({ type: 'shop-pick-list-print-done' }, ${JSON.stringify(window.location.origin)});
          } catch (e) {}
        };
        window.addEventListener('afterprint', finish);
        try {
          var media = window.matchMedia('print');
          var onChange = function (event) {
            if (!event.matches) finish();
          };
          if (media.addEventListener) media.addEventListener('change', onChange);
        } catch (e) {}
        setTimeout(function () {
          window.focus();
          window.print();
        }, 200);
      })();
    </script>
    </body></html>`;
  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.cssText = 'position:fixed;left:-10000px;top:0;width:1056px;height:816px;border:0;';
  const onMessage = (event) => {
    if (event.origin !== window.location.origin) return;
    if (!event.data || event.data.type !== 'shop-pick-list-print-done') return;
    window.removeEventListener('message', onMessage);
    setTimeout(() => {
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    }, 300);
  };
  window.addEventListener('message', onMessage);
  document.body.appendChild(iframe);
  const frameWindow = iframe.contentWindow;
  if (!frameWindow) {
    window.removeEventListener('message', onMessage);
    iframe.remove();
    return;
  }
  frameWindow.document.open();
  frameWindow.document.write(html);
  frameWindow.document.close();
};



// WEBPACK FOOTER //
// ./src/components/marketplace-bins/pickList.js